// Fetch list

export const FETCH = 'warehousingWarehouses.FETCH'
export const FETCH_STARTED = 'warehousingWarehouses.FETCH_STARTED'
export const FETCH_FULFILLED = 'warehousingWarehouses.FETCH_FULFILLED'
export const FETCH_REJECTED = 'warehousingWarehouses.FETCH_REJECTED'
export const FETCH_CANCELLED = 'warehousingWarehouses.FETCH_CANCELLED'

export const SORTING_CHANGED = 'warehousingWarehouses.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'warehousingWarehouses.FETCH_ONE'
export const FETCH_ONE_STARTED = 'warehousingWarehouses.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'warehousingWarehouses.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'warehousingWarehouses.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'warehousingWarehouses.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'warehousingWarehouses.SAVE'
export const SAVE_STARTED = 'warehousingWarehouses.SAVE_STARTED'
export const SAVE_FULFILLED = 'warehousingWarehouses.SAVE_FULFILLED'
export const SAVE_REJECTED = 'warehousingWarehouses.SAVE_REJECTED'
export const SAVE_CANCELLED = 'warehousingWarehouses.SAVE_CANCELLED'

// Delete

export const DELETE = 'warehousingWarehouses.DELETE'
export const DELETE_STARTED = 'warehousingWarehouses.DELETE_STARTED'
export const DELETE_FULFILLED = 'warehousingWarehouses.DELETE_FULFILLED'
export const DELETE_REJECTED = 'warehousingWarehouses.DELETE_REJECTED'
export const DELETE_CANCELLED = 'warehousingWarehouses.DELETE_CANCELLED'

// Export

export const EXPORT = 'warehousingWarehouses.EXPORT'
export const EXPORT_FULFILLED = 'warehousingWarehouses.EXPORT_FULFILLED'
